import { ChangeDetectionStrategy, Component, Input, signal } from '@angular/core';

export type CdcWaitingPhase = 'loading' | 'submitting' | 'bank';

/**
 * Stato di attesa del flusso carta:
 * - 'loading'    → caricamento iniziale (fetch paymentAuth), solo spinner
 * - 'submitting' → invio dati carta al backend
 * - 'bank'       → utente sulla pagina 3DS della banca, in attesa dell'esito
 */
@Component({
  selector: 'yf-cdc-waiting',
  templateUrl: './cdc-waiting.component.html',
  styleUrls: ['./cdc-waiting.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class CdcWaitingComponent {
  $phase = signal<CdcWaitingPhase>('loading');

  @Input() set phase(v: CdcWaitingPhase | null | undefined) {
    this.$phase.set(v ?? 'loading');
  }

  stepState(step: 'submit' | 'bank'): 'done' | 'active' | 'pending' {
    const phase = this.$phase();
    if (step === 'submit') return phase === 'submitting' ? 'active' : 'done';
    return phase === 'bank' ? 'active' : 'pending';
  }
}
